import styled, { css } from 'styled-components';
import { blockTokens } from '../../../tokens/components/Block/tokens';

export const BlockHeaderWrapper = styled.div`
  border-bottom: ${blockTokens.CoreBorderStyle};
  padding: ${blockTokens.CoreSpacingBox};
  position: relative;
  text-align: center;

  ${({ theme }) =>
    theme.transparent &&
    css`
      align-items: center;
      border-bottom: 0;
      display: flex;
      padding-bottom: 0.5rem;
      text-align: left;
    `}
`;

export const BlockHeaderTitleWrapper = styled.div`
  margin: 0;
  padding: 0 36px;

  ${({ theme }) =>
    theme.transparent &&
    css`
      padding: 0;
    `}
`;
